// Shared tier preview data — used by GraduationCard and Journey page
// Teasers: a single evocative line per tier, no spoilers (no genes/stars/Enochian terms)
// Garments: emoji + name only — silhouette-style fogged-glass preview

export const TIER_TEASERS = {
  "Seed": { emoji: "\u{1F331}", line: "the awareness of stardust ancestry stirring in your blood" },
  "Gah-Vree-eL": { emoji: "\u{1F4AB}", line: "the strength of God remembering you" },
  "Rah-Fay-eL": { emoji: "\u{1F319}", line: "the language of dreams begins to translate itself" },
  "You-Rel": { emoji: "\u{1F3AD}", line: "the social mask falls away from the truer face beneath" },
  "Rakes-Isle": { emoji: "\u{1F50D}", line: "stress softens into curiosity, and Lady Wisdom comes close" },
  "Hah-Nile": { emoji: "\u{1F33A}", line: "joy as an act of will — the garden path begins to glow" },
  "Zad-Kay-EL": { emoji: "\u2728", line: "gratitude opens the door for revelation to enter" },
  "Kah-May-EL": { emoji: "\u{1F9ED}", line: "synchronicities begin to braid into a single golden thread" },
  "Ay-Rass-Nigh": { emoji: "\u{1F30C}", line: "a holy void asks you to step in without your old armour" },
  "Oaks-Oh-So": { emoji: "\u{1F9E0}", line: "the right brain begins to repair what the left brain broke" },
  "Ay-Rass-L": { emoji: "\u{1F43E}", line: "a primal animal stirs at the root of your spine" },
  "Yah-Dahl": { emoji: "\u{1F3A8}", line: "creative animal cousins arrive to play" },
  "May-Day-L": { emoji: "\u{1F52E}", line: "your personal symbols become a private language with the divine" },
  "Mah-Row": { emoji: "\u{1F525}", line: "the spirit-body learns delayed gratification as devotion" },
  "Nah-Tay-Ah": { emoji: "\u2764\uFE0F", line: "a whirlwind of love-fuelled action wants to move through you" },
  "Bat-Eye-Larrotol": { emoji: "\u231B", line: "patterns from every prior tier begin to weave together — in the present moment only" },
  "Lay-Bez-Ez": { emoji: "\u{1F30A}", line: "obstacles reveal themselves as the music of God" },
  "Halla-San": { emoji: "\u{1F6E1}\uFE0F", line: "mercy through capacity — strength found by looking up" },
  "Yay-R": { emoji: "\u{1F339}", line: "no longer an ego, but a plurality — the protector awakens" },
  "Sandalphon": { emoji: "\u{1F40A}", line: "the whispering fears fall silent — God takes the battle" },
  "Air-Ah-Tahs": { emoji: "\u{1FA84}", line: "the staff of time bends — your intention writes the next page" },
  "Razel": { emoji: "\u267E\uFE0F", line: "fully inhabit the body while knowing only spirit crosses the finish line" },
  "Payx-R": { emoji: "\u{1F49D}", line: "you are enough in the hands of God, just as you are" },
  "Azap-Azorendez": { emoji: "\u{1F9F0}", line: "act on what you know — lightning from revelation to the common world" },
  "Eye-Bah-Pohd Bay-Min-O-Dee": { emoji: "\u{1F9BE}", line: "weave the great pattern into daily habits — bridge to the Holy Guardian Angel" },
};

// Garment silhouettes for the upcoming tier — kept abstract so it feels mystical, not spoiled
export const TIER_GARMENT_PREVIEW = {
  "Seed": { emoji: "\u{1F331}", name: "Seedling Shawl" },
  "Gah-Vree-eL": { emoji: "\u{1F49C}", name: "Mantle of the Universal Soul" },
  "Rah-Fay-eL": { emoji: "\u{1F319}", name: "Dreamweaver Robe" },
  "You-Rel": { emoji: "\u{1F3AD}", name: "Fool Motley" },
  "Rakes-Isle": { emoji: "\u{1F50D}", name: "Curiosity Cape" },
  "Hah-Nile": { emoji: "\u{1F33A}", name: "Garden Vestment" },
  "Zad-Kay-EL": { emoji: "\u2728", name: "Gratitude Stole" },
  "Kah-May-EL": { emoji: "\u{1F9ED}", name: "Synchronicity Sash" },
  "Ay-Rass-Nigh": { emoji: "\u{1F30C}", name: "Void-Walker Shroud" },
  "Oaks-Oh-So": { emoji: "\u{1F9E0}", name: "Crown-Mind Turban" },
  "Ay-Rass-L": { emoji: "\u{1F43E}", name: "Animal Pelt" },
  "Yah-Dahl": { emoji: "\u{1F3A8}", name: "Kerubim Weave" },
  "May-Day-L": { emoji: "\u{1F52E}", name: "Symbol-Reader Vestment" },
  "Mah-Row": { emoji: "\u{1F525}", name: "Phoenix Wrap" },
  "Nah-Tay-Ah": { emoji: "\u2764\uFE0F", name: "Love-Storm Cloak" },
  "Bat-Eye-Larrotol": { emoji: "\u231B", name: "Present-Moment Tunic" },
  "Lay-Bez-Ez": { emoji: "\u{1F30A}", name: "Miracle-River Robe" },
  "Halla-San": { emoji: "\u{1F6E1}\uFE0F", name: "Mercy Armour" },
  "Yay-R": { emoji: "\u{1F339}", name: "Rose Rider Jacket" },
  "Sandalphon": { emoji: "\u{1F40A}", name: "Crocodile Hide Overcoat" },
  "Air-Ah-Tahs": { emoji: "\u{1FA84}", name: "Magic Wand" },
  "Razel": { emoji: "\u267E\uFE0F", name: "Eternal-Spirit Joggers" },
  "Payx-R": { emoji: "\u{1F49D}", name: "Self-Acceptance Tactical Pants" },
  "Azap-Azorendez": { emoji: "\u{1F9F0}", name: "Workers' Lunchbox" },
  "Eye-Bah-Pohd Bay-Min-O-Dee": { emoji: "\u{1F9BE}", name: "Exosuit of Praxis" },
};
